import { Typography } from '@euler/app/components/typography';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { BiTimeRange, BiTimeRangeKind } from '@euler/model/bi/query';
import { memo, useEffect, useState } from 'react';
import { View } from 'react-native';
import { RangeTextInput } from './RangeTextInput';
import { biAbsoluteInput } from './functions/biRangeInput';

/** Two named dates, inclusive; the range then stays fixed. */
export const AbsoluteRangeFields = memo(
  ({
    value,
    onPick,
  }: {
    value: BiTimeRange | undefined;
    onPick: (range: BiTimeRange) => void;
  }) => {
    const { rpx } = useResponsiveContext();
    const absolute = value?.kind === BiTimeRangeKind.Absolute ? value : null;
    const [from, setFrom] = useState(absolute?.from ?? '');
    const [to, setTo] = useState(absolute?.to ?? '');
    useEffect(() => {
      setFrom(absolute?.from ?? '');
      setTo(absolute?.to ?? '');
    }, [absolute?.from, absolute?.to]); // eslint-disable-line react-hooks/exhaustive-deps
    const input = biAbsoluteInput(from, to);
    const change = (nextFrom: string, nextTo: string) => {
      setFrom(nextFrom);
      setTo(nextTo);
      const typed = biAbsoluteInput(nextFrom, nextTo);
      if (typed.kind === 'ok') onPick(typed.range);
    };
    return (
      <View style={{ gap: rpx(6) }}>
        <View
          style={{
            flexDirection: 'row',
            flexWrap: 'wrap',
            alignItems: 'center',
            gap: rpx(6),
          }}
        >
          <Typography.Text
            size={rpx(12)}
            color={absolute ? aiColors.primary : aiColors.foreground}
          >
            指定日期
          </Typography.Text>
          <RangeTextInput
            label="开始日期"
            value={from}
            placeholder="2026-01-01"
            width={104}
            onChange={text => change(text, to)}
          />
          <Typography.Text size={rpx(12)} color={aiColors.mutedForeground}>
            至
          </Typography.Text>
          <RangeTextInput
            label="结束日期"
            value={to}
            placeholder="2026-03-31"
            width={104}
            onChange={text => change(from, text)}
          />
        </View>
        {input.kind === 'invalid' && from.length >= 10 && to.length >= 10 ? (
          <Typography.Text size={rpx(11)} color={aiColors.destructive}>
            {input.problem}
          </Typography.Text>
        ) : null}
      </View>
    );
  },
);
